module.exports = __webpack_public_path__ + "img/cm-qr.62e58e97.jpg";